const getApiUrl = () => {
  // Check if we're running on localhost
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';
  
  if (isLocalhost) {
    return 'http://localhost:3001';
  }
  
  return 'https://actionverbs.pablothiermann.com';
};

export const API_URL = getApiUrl();

export const ENDPOINTS = {
  analyze: `${API_URL}/api/analyze`,
  logs: `${API_URL}/api/logs`
}; 